import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;

  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;

  border-top: 1px solid ${Colors.GS400};

  padding: 8px 0px;

  &:last-child {
    border-bottom: 1px solid ${Colors.GS400};
  }
`;
export const EmptyState = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
`;
export const CheckboxContainer = styled.div `
  margin-right: 16px;
`;
export const Nickname = styled.div `
  margin-left: 16px;
  margin-right: auto;
`;
export const TableContainer = styled.div `
  margin-top: 16px;
  min-height: 50px;
  max-height: 220px;
  overflow-y: scroll;
`;
